<template>
    <div>
        <div class="border rounded-sm pt-4 pl-4 pr-4">
            <ValidationObserver ref="updateFormValidate">
                <b-tabs content-class="py-5 position-relative" class="line-tabs" fill>
                    <div class="tabs-bottom-line"></div>
                    <b-tab :active="tabIndex == -1" @click="tabIndex = -1">
                        <template #title>
                            {{ $t('login_details') }}
                        </template>
                        <template>
                            <b-row>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('national_id')">
                                            <b-form-input v-model="formData.national_id"
                                                          :disabled="true"/>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" lg="4">
                                    <b-form-group :label="$t('pin')">
                                            <b-form-input v-model="formData.pin"
                                                          :disabled="true"/>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </template>
                    </b-tab>
                    <b-tab :active="tabIndex == 0" @click="tabIndex = 0">
                        <template #title>
                            {{ $t('personal_info') }}
                        </template>
                        <template>
                                <h6>{{ $t('identity_information') }}</h6>
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('national_id')">
                                                <ValidationProvider name="national_id" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.national_id"
                                                                  :state="errors[0] ? false : null" :disabled="true" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('name')">
                                                <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.name"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="true"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('surname')">
                                                <ValidationProvider name="surname" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.surname"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="true"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <ValidationProvider name="birthdate" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('birthdate')">
                                                    <select-date v-model="formData.birthdate" :validationError="errors[0]" :disabled="true" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('birthplace')">
                                                <ValidationProvider name="birthplace" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.birthplace"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="!updateMode"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <ValidationProvider name="gender" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('gender')">
                                                    <gender-selectbox v-model="formData.gender"
                                                                      :validateError="errors[0]"
                                                                      :disabled="!updateMode"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <ValidationProvider name="nationality_code" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('nationality')">
                                                    <nationality-selectbox v-model="formData.nationality_code"
                                                                           :validateError="errors[0]"
                                                                           :disabled="!updateMode"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('father_name')">
                                                <ValidationProvider name="father_name" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.father_name"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="!updateMode"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('mother_name')">
                                                <ValidationProvider name="mother_name" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.mother_name"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="!updateMode"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12">
                                            <b-button variant="outline-primary" class="mb-4" v-if="formData.identity_document" @click="downloadFile('identity_file')">
                                                <i class="ri-download-2-line font-size-16 mr-2"></i> {{$t('identity_card_placeholder')}}
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </div>

                                <h6>{{ $t('contact_information') }}</h6>
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('email')">
                                                <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.email"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="!updateMode"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('gsm_no')">
                                                <ValidationProvider name="mobile_tel" rules="required" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.mobile_tel"
                                                                  v-mask="'### ### ## ##'"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="!updateMode"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('alternative_tel')">
                                                <ValidationProvider name="alternative_mobile_tel" rules="" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.alternative_mobile_tel"
                                                                  v-mask="'### ### ## ##'"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="!updateMode"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>

                                <b-row>
                                    <b-col cols="12" md="6">
                                        <h6>{{ $t('residence_address') }}</h6>
                                        <div class="border p-4 rounded-sm mb-3">
                                            <b-row>
                                                <b-col cols="12" md="6" lg="6">
                                                    <ValidationProvider name="city" rules="" v-slot="{ errors }">
                                                        <b-form-group :label="$t('city')">
                                                            <city-selectbox v-model="formData.city"
                                                                            :validateError="errors[0]"
                                                                            :disabled="!updateMode"/>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="6" lg="6">
                                                    <ValidationProvider name="district" rules="" v-slot="{ errors }">
                                                        <b-form-group :label="$t('district')">
                                                            <district-outline-selectbox v-model="formData.district"
                                                                                        :city_id="formData.city"
                                                                                        :validateError="errors[0]"
                                                                                        :disabled="!updateMode"/>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="12" lg="12">
                                                    <ValidationProvider name="address" rules="" v-slot="{ errors }">
                                                        <b-form-group :label="$t('address')">
                                                            <b-form-textarea v-model="formData.address" rows="3"
                                                                             :state="errors[0] ? false : null"
                                                                             :disabled="!updateMode"/>
                                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="6" lg="6">
                                                    <b-form-group :label="$t('postal_code')">
                                                        <ValidationProvider name="postal_code" rules="" v-slot="{ errors }">
                                                            <b-form-input v-model="formData.postal_code"
                                                                          :state="errors[0] ? false : null"
                                                                          :disabled="!updateMode"/>
                                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                        </ValidationProvider>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <h6>{{ $t('communication_address') }}</h6>
                                        <div class="border p-4 rounded-sm mb-3">
                                            <b-row>
                                                <b-col cols="12" md="6" lg="6">
                                                    <ValidationProvider name="contact_city" rules="" v-slot="{ errors }">
                                                        <b-form-group :label="$t('city')">
                                                            <city-selectbox v-model="formData.contact_city"
                                                                            :validateError="errors[0]"
                                                                            :disabled="!updateMode"/>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="6" lg="6">
                                                    <ValidationProvider name="contact_district" rules="" v-slot="{ errors }">
                                                        <b-form-group :label="$t('district')">
                                                            <district-outline-selectbox v-model="formData.contact_district"
                                                                                        :city_id="formData.contact_city"
                                                                                        :validateError="errors[0]"
                                                                                        :disabled="!updateMode"/>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="12" lg="12">
                                                    <ValidationProvider name="contact_address" rules="" v-slot="{ errors }">
                                                        <b-form-group :label="$t('address')">
                                                            <b-form-textarea v-model="formData.contact_address" rows="3"
                                                                             :state="errors[0] ? false : null"
                                                                             :disabled="!updateMode"/>
                                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="6" lg="6">
                                                    <b-form-group :label="$t('postal_code')">
                                                        <ValidationProvider name="contact_postal_code" rules="" v-slot="{ errors }">
                                                            <b-form-input v-model="formData.contact_postal_code"
                                                                          :state="errors[0] ? false : null"
                                                                          :disabled="!updateMode"/>
                                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                        </ValidationProvider>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </b-col>
                                </b-row>
                            <h6>{{ $t('health_information') }}</h6>
                            <div class="border p-4 rounded-sm mb-3">
                                <b-row>
                                    <b-col cols="12" md="6" lg="4">
                                        <ValidationProvider name="disability" rules="" v-slot="{ errors }">
                                            <b-form-group :label="$t('disability_status')">
                                                <multi-selectbox v-model="formData.disability"
                                                                 :options="disabilityOptions"
                                                                 :multiple="false"
                                                                 :validateError="errors[0]"
                                                                 :disabled="!updateMode" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12" md="6" lg="8" class="mt-5">
                                        <b-button variant="outline-primary" class="mb-4 mt-1" v-if="formData.disability_document" @click="downloadFile('disability_file')">
                                            <i class="ri-download-2-line font-size-16 mr-2"></i> {{$t('file_download')}}
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </div>
                        </template>
                    </b-tab>
                    <b-tab :active="tabIndex == 1" @click="tabIndex = 1">
                        <template #title>
                            {{ $t('education_info') }}
                        </template>
                        <template>
                                <h6>{{ $t('high_school_info') }}</h6>
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('graduate_high_school_name')">
                                                <ValidationProvider name="school_name" rules="" v-slot="{ errors }">
                                                    <highschool-auto-complete-cartoon-animation
                                                        :disabled="!updateMode"
                                                        v-model="formData.school_name"
                                                        :national-id="formData.national_id"
                                                        :pin="formData.pin"
                                                        @selectedObject="selectedSchool"
                                                        :validateError="errors[0]" />
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('high_school_diploma_score')">
                                                <ValidationProvider name="school_diploma_point" rules="" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.school_diploma_point"
                                                                  type="number"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="!updateMode"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <ValidationProvider name="school_major_type" rules="" v-slot="{ errors }">
                                                <b-form-group :label="$t('high_school_major_type')">
                                                    <multi-selectbox v-model="formData.school_major_type"
                                                                     :options="schoolMajorTypeOptions"
                                                                     :multiple="false"
                                                                     :validateError="errors[0]"
                                                                     :disabled="!updateMode"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('graduate_high_school_code')">
                                                <ValidationProvider name="school_code" rules="" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.school_code"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="true"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <ValidationProvider name="school_graduate_date" rules="" v-slot="{ errors }">
                                                <b-form-group :label="$t('high_school_graduate_date')">
                                                    <select-date v-model="formData.school_graduate_date" :validationError="errors[0]" :disabled="!updateMode" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('obp_point')">
                                                <ValidationProvider name="school_name" rules="" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.obp_point"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="true"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="8">
                                            <ValidationProvider name="before_placed" rules="" v-slot="{ errors }">
                                                <b-form-group :label="$t('before_placed')">
                                                    <multi-selectbox v-model="formData.before_placed"
                                                                     :options="beforePlacedOptions"
                                                                     :multiple="false"
                                                                     :validateError="errors[0]"
                                                                     :disabled="!updateMode"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                </div>
                                <h6>{{ $t('exam_info') }}</h6>
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('tyt_year')">
                                                <ValidationProvider name="exam_year" rules="" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.exam_year"
                                                                  type="number"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="true"/>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4">
                                            <b-form-group :label="$t('tyt_score')">
                                                <ValidationProvider name="exam_point" rules="" v-slot="{ errors }">
                                                    <b-form-input v-model="formData.tyt_point"
                                                                  type="number"
                                                                  :state="errors[0] ? false : null"
                                                                  :disabled="true"/>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                    <b-form-text id="input-live-help">{{ $t('tyt_info') }}</b-form-text>
                                                </ValidationProvider>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>
                            <h6>{{ $t('university_informations') }}</h6>
                            <div class="border p-4 rounded-sm mb-3">
                                <b-row>
                                    <b-col cols="12" md="6" lg="4">
                                        <b-form-group :label="$t('accepted_university_in', { year: 2025 })">
                                            <ValidationProvider name="has_university_enrollment" rules="required" v-slot="{ errors }">
                                                <multi-selectbox v-model="formData.has_university_enrollment"
                                                                 :options="yesNoOptions"
                                                                 :multiple="false"
                                                                 :disabled="!updateMode"
                                                                 :validateError="errors[0]" />
                                            </ValidationProvider>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="formData.has_university_enrollment == 'E'">
                                    <b-col cols="12" md="6" lg="6">
                                        <ValidationProvider name="university_barcode_no" rules="required" v-slot="{ errors }">
                                            <b-form-group :label="$t('document_barcode_no')">
                                                <b-form-input v-model="formData.university_barcode_no"
                                                              :disabled="!updateMode"
                                                              :state="errors[0] ? false : null" />
                                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                <b-form-text id="input-live-help">{{ $t('document_barcode_no_info') }}</b-form-text>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                            </div>
                        </template>
                    </b-tab>
                    <b-tab :active="tabIndex == 2" @click="tabIndex = 2">
                        <template #title>
                            {{ $t('application_information') }}
                        </template>
                        <template>
                            <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="4">
                                            <ValidationProvider name="program_code" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('program_select')">
                                                    <program-selectbox v-model="formData.program_code"
                                                                       :faculty_code="'03'"
                                                                       :validateError="errors[0]"
                                                                       :disabled="true" />
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider name="interview_type" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('interview_preference')">
                                                    <parameter-selectbox v-model="formData.interview_type"
                                                                         code="cartoon_animation_application_interview_preference"
                                                                         :multiple="false"
                                                                         :validateError="errors[0]"
                                                                         :disabled="!updateMode" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col cols="12" md="8">
                                            <b-row>
                                                <b-col cols="12" md="6" class="mt-1">
                                                    <span class="text-black-75">{{$t('portfolio')+' 1'}}</span>
                                                    <b-button variant="outline-primary" class="mt-1" v-if="formData.portfolio_document" @click="downloadFile('portfolio_file')">
                                                        <i class="ri-download-2-line font-size-16 mr-2"></i> {{$t('file_download')}}
                                                    </b-button>
                                                </b-col>
                                                <b-col cols="12" md="6" class="mt-1">
                                                    <span class="text-black-75">{{$t('portfolio')+' 2'}}</span>
                                                    <b-button variant="outline-primary" class="mt-1" v-if="formData.second_portfolio_document" @click="downloadFile('second_portfolio_file')">
                                                        <i class="ri-download-2-line font-size-16 mr-2"></i> {{$t('file_download')}}
                                                    </b-button>
                                                </b-col>
                                                <b-col cols="12" class="mt-3">
                                                    <b-form-group :label="$t('portfolio_share_link')+' 1'">
                                                        <ValidationProvider name="portfolio_link" rules="" v-slot="{ errors }">
                                                            <b-form-input v-model="formData.portfolio_link"
                                                                          :disabled="!updateMode"
                                                                          :state="errors[0] ? false : null" />
                                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                        </ValidationProvider>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12">
                                                    <b-form-group :label="$t('portfolio_share_link')+' 2'">
                                                        <ValidationProvider name="second_portfolio_link" rules="" v-slot="{ errors }">
                                                            <b-form-input v-model="formData.second_portfolio_link"
                                                                          :disabled="!updateMode"
                                                                          :state="errors[0] ? false : null" />
                                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                                        </ValidationProvider>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </div>
                        </template>
                    </b-tab>
                    <b-tab :active="tabIndex == 3" @click="tabIndex = 3">
                        <template #title>
                            {{ $t('payment') }}
                        </template>
                        <template>
                            <ValidationObserver ref="paymentFormValidate">
                                <h6>{{ $t('cartoon_animation_app_payment_info') }}</h6>
                                <div class="border p-4 rounded-sm mb-3">
                                    <b-row>
                                        <b-col cols="12" md="6">
                                            <b-alert variant="dark" show>
                                                <h3 class="mt-1" v-if="formData.exam_price == null">{{ $t('payment_total')+' : 0 TL' }}</h3>
                                                <h3 class="mt-1" v-else>{{ $t('payment_total')+' : '+formData.exam_price+' TL' }}</h3>
                                            </b-alert>
                                            <b-alert variant="success" show v-if="formData.payment_status == 'E'">
                                                <span class="font-size-20 font-weight-bold">{{$t('payment_success')}}</span>
                                            </b-alert>
                                            <b-alert variant="danger" show v-else>
                                                <span class="font-size-20 font-weight-bold">{{$t('payment_not_paid')}}</span>
                                            </b-alert>
                                        </b-col>
                                        <b-col cols="12" md="6">
                                            <ValidationProvider name="payment_status" rules="" v-slot="{ errors }">
                                                <b-form-group :label="$t('payment_status')">
                                                    <multi-selectbox v-model="formData.payment_status"
                                                                     :options="beforePlacedOptions"
                                                                     :multiple="false"
                                                                     :validateError="errors[0]"
                                                                     />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                </div>
                            </ValidationObserver>
                        </template>
                    </b-tab>
                    <b-tab :active="tabIndex == 4" @click="tabIndex = 4">
                        <template #title>
                            {{ $t('special_talent_exam') }}
                        </template>
                        <template>
                            <h6>{{ $t('exam_info') }}</h6>
                            <div class="border p-4 rounded-sm mb-3">
                                <b-row>
                                    <b-col cols="12">
                                        <b-table :empty-filtered-text="$t('no_result')"
                                                 :empty-text="$t('no_result')"
                                                 bordered
                                                 responsive
                                                 :items="examResultData"
                                                 :fields="examResultFields"
                                                 show-empty
                                                 class="mb-4 table-dropdown no-scrollbar border rounded">
                                            <template #cell(buttons)="row">
                                                <b-dropdown variant="link btn-sm" boundary="window" no-caret v-if="updateMode">
                                                    <template #button-content>
                                                        <i class="ri-more-fill"></i>
                                                    </template>
                                                    <div id="dropdownListHead">
                                                        <b-dropdown-item v-if="checkPermission('cartoonanimationapplicationexam_update')" @click="openExamUpdate(row.item)">
                                                            <i class="ri-edit-box-line align-middle top-minus-1 mr-3 text-muted"></i> {{$t('edit')}}
                                                        </b-dropdown-item>
                                                    </div>
                                                </b-dropdown>
                                            </template>
                                            <template #cell(rank)="row">
                                                {{row.item.rank+'.'+$t('preference')}}
                                            </template>
                                            <template #cell(program)="row">
                                                <span v-if="row.item.program_detail">
                                                    {{row.item.program+' ('+row.item.program_detail+')'}}
                                                </span>
                                                <span v-else>
                                                    {{row.item.program}}
                                                </span>
                                            </template>
                                        </b-table>
                                    </b-col>
                                </b-row>
                            </div>

                            <h6>{{ $t('exam_result') }}</h6>
                            <div class="border p-4 rounded-sm mb-3">
                                <b-row>
                                    <b-col cols="6" md="6" class="text-right text-black-50 font-size-16">{{ formData.program_name+' - '+$t('exam_score').toUpper() }}</b-col>
                                    <b-col cols="6" md="6" class="text-size-16">{{formData.exam_point != null ? formData.exam_point : '---'}}</b-col>
                                </b-row>
                            </div>
                            <div class="border p-4 rounded-sm mb-3" v-if="formData.second_program_name && formData.second_program_detail[0]">
                                <b-row>
                                    <b-col cols="6" md="6" class="text-right text-black-50 font-size-16">{{ formData.second_program_name+' ('+$t(formData.second_program_detail[0])+') - '+$t('exam_score').toUpper() }}</b-col>
                                    <b-col cols="6" md="6" class="text-size-16">{{formData.second_exam_point != null ? formData.second_exam_point : '---'}}</b-col>
                                </b-row>
                            </div>
                            <div class="border p-4 rounded-sm mb-3" v-else-if="formData.second_program_name">
                                <b-row>
                                    <b-col cols="6" md="6" class="text-right text-black-50 font-size-16">{{ formData.second_program_name+' - '+$t('exam_score').toUpper() }}</b-col>
                                    <b-col cols="6" md="6" class="text-size-16">{{formData.second_exam_point != null ? formData.second_exam_point : '---'}}</b-col>
                                </b-row>
                            </div>
                        </template>
                    </b-tab>
                    <b-tab :active="tabIndex == 5" @click="tabIndex = 5">
                        <template #title>
                            {{ $t('application_status') }}
                        </template>
                        <template>
                            <h6>{{ $t('estimate_status') }}</h6>
                            <div class="border p-4 rounded-sm mb-3">
                                <b-alert show variant="secondary" v-for="(itm,key) in formData.messages" :key="key">
                                    <b-row>
                                        <b-col cols="12" md="1" class="d-flex justify-content-center">
                                            <b-button variant="primary" @click="updateMessage(itm)"><i class="ri-mail-unread-line"></i></b-button>
                                        </b-col>
                                        <b-col cols="12" md="8">
                                            {{itm.message}}
                                        </b-col>
                                        <b-col cols="12" md="2" class="text-center">
                                            <b-badge variant="dark">{{itm.date}}</b-badge>
                                        </b-col>
                                        <b-col cols="12" md="1" class="d-flex justify-content-center">
                                            <b-button pill variant="link" class="text-danger" @click="deleteMessage(itm.id)"><i class="ri-close-line"></i></b-button>
                                        </b-col>
                                    </b-row>
                                </b-alert>
                                <hr>
                                <b-alert show variant="secondary">
                                    <b-row>
                                        <b-col cols="9" md="10">
                                            <b-row>
                                                <b-col cols="12" :md="msgUpdateMode ? 9 : 12">
                                                    <ValidationProvider name="message" rules="" v-slot="{errors}">
                                                        <b-form-group>
                                                            <b-form-textarea v-model="message"
                                                                             :class="errors[0] ? 'is-invalid':''"
                                                                             rows="3"
                                                                             :placeholder="$t('message')"
                                                            />
                                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" md="3" v-if="msgUpdateMode">
                                                    <select-date v-model="msgDate"/>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col cols="3" md="2">
                                            <b-button block variant="primary" @click="sendMessage" v-if="!msgUpdateMode">
                                                {{$t('send')}}
                                            </b-button>
                                            <b-button block variant="warning" @click="_updateMessage" v-if="msgUpdateMode">
                                                {{$t('update')}}
                                            </b-button>
                                            <b-button block variant="primary" @click="newMessage" v-if="msgUpdateMode">
                                                {{$t('new')}}
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-alert>
                            </div>
                        </template>
                    </b-tab>
                </b-tabs>
                <div class="d-flex justify-content-center mb-3">
                    <processing-button :processing="formLoading" variant="primary" v-if="updateMode && tabIndex != 4"
                                       :label="$t('save')" @click="updateForm" />
                </div>
            </ValidationObserver>
            <CommonModal id="examUpdateModal" size="lg" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit') }}
                </template>
                <template v-slot:CommonModalContent>
                    <ValidationObserver ref="examUpdateFormValidate">
                    <b-row v-if="examUpdateData">
                        <b-col cols="12">
                            <ValidationProvider name="program_code" rules="required" v-slot="{ errors }">
                                <b-form-group :label="$t('program')">
                                    <program-selectbox v-model="examUpdateData.program_code"
                                                       :public="true"
                                                       :major_type="'A'"
                                                       :faculty_code="'03'"
                                                       :disabled="true"
                                                       :validateError="errors[0]" />
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12">
                            <ValidationProvider name="exam_type" rules="required" v-slot="{ errors }">
                                <b-form-group :label="$t('exam_type')">
                                    <parameter-selectbox v-model="examUpdateData.exam_type"
                                                       code="cartoon_animation_application_exam_types"
                                                       :validateError="errors[0]" />
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider name="exam_location" rules="" v-slot="{ errors }">
                                <b-form-group :label="$t('exam_place')">
                                    <campus-selectbox-no-cache v-model="examUpdateData.exam_location"
                                                               return-type="name"
                                                               :validateError="errors[0]" />
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider name="classroom" rules="" v-slot="{ errors }">
                                <b-form-group :label="$t('classroom')">
                                    <b-form-input
                                        v-model="examUpdateData.classroom"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider name="exam_date" rules="" v-slot="{errors}">
                                <b-form-group :label="$t('date')">
                                    <b-form-input
                                        type="date"
                                        v-model="examUpdateData.exam_date"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider name="exam_hour" rules="" v-slot="{errors}">
                                <b-form-group :label="$t('hour')">
                                    <b-form-input
                                        v-model="examUpdateData.exam_hour"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12">
                            <ValidationProvider name="point" rules="" v-slot="{errors}">
                                <b-form-group :label="$t('grade')">
                                    <b-form-input
                                        type="number"
                                        v-model="examUpdateData.point"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>

                        <b-col cols="12" class="d-flex justify-content-center">
                            <b-button variant="primary" @click="updateExamData">{{ $t('save') }}</b-button>
                        </b-col>
                    </b-row>
                    </ValidationObserver>
                </template>
            </CommonModal>
        </div>
    </div>
</template>

<script>
    // Component
    import NationalitySelectbox from '@/components/interactive-fields/NationalitySelectbox'
    import CitySelectbox from '@/components/interactive-fields/CitySelectbox'
    import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox"
    import ProcessingButton from '@/components/elements/ProcessingButton'
    import CampusSelectboxNoCache from "@/components/interactive-fields/CampusSelectboxNoCache"
    import CommonModal from '@/components/elements/CommonModal'
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox"
    import ClassroomSelectbox from "@/components/interactive-fields/ClassroomSelectbox"
    import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
    import HighschoolAutoCompleteCartoonAnimation from "@/components/interactive-fields/HighschoolAutoCompleteCartoonAnimation"

    // Service
    import CartoonAnimationService from "@/services/CartoonAnimationService"

    // Other
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
    import Branchs from "@/modules/cartoonAnimationApplication/data/Branchs"
    import moment from "moment";
    import qs from "qs";
    import YearsSelectbox from "@/components/interactive-fields/YearsSelectbox.vue";


    export default {
        props: {
            updateData: {
                type: Object
            },
            updateMode: {
                type: Boolean,
                default: false
            },
            goTab: {
                type: Number,
                default: 0
            }
        },

        components: {
            HighschoolAutoCompleteCartoonAnimation,
            YearsSelectbox,
            ValidationObserver,
            ValidationProvider,
            NationalitySelectbox,
            CitySelectbox,
            DistrictOutlineSelectbox,
            ProcessingButton,
            CampusSelectboxNoCache,
            CommonModal,
            ParameterSelectbox,
            ClassroomSelectbox,
            MultiSelectbox
        },

        data() {
            return {
                formData: {},
                tabIndex: 0,

                schoolMajorTypeOptions: [
                    { value: null, text: '' },
                    { value: this.$t('high_school_major_type_1'), text: this.$t('high_school_major_type_1') },
                    { value: this.$t('high_school_major_type_2'), text: this.$t('high_school_major_type_2') },
                    { value: this.$t('high_school_major_type_3'), text: this.$t('high_school_major_type_3') },
                    { value: this.$t('high_school_major_type_4'), text: this.$t('high_school_major_type_4') },
                    { value: this.$t('high_school_major_type_5'), text: this.$t('high_school_major_type_5') },
                    { value: this.$t('high_school_major_type_6'), text: this.$t('high_school_major_type_6') },
                ],

                branchOptions: null,
                formLoading: false,
                message: null,
                msgUpdateMode: false,
                msgDate: null,
                msgId: null,
                disabilityOptions: [
                    { value: 'H', text: this.$t('none') },
                    { value: 'E', text: this.$t('available') }
                ],
                examResultData: [],
                examResultFields: [
                    {
                        key: 'buttons',
                        label: '',
                    },
                    {
                        key: 'program',
                        label: this.$t('program'),
                    },
                    {
                        key: 'exam_type_name',
                        label: this.$t('exam_type'),
                    },
                    {
                        key: 'exam_location',
                        label: this.$t('exam_place'),
                    },
                    {
                        key: 'classroom',
                        label: this.$t('classroom'),
                    },
                    {
                        key: 'exam_date',
                        label: this.$t('exam_date'),
                    },
                    {
                        key: 'exam_hour',
                        label: this.$t('exam_hour'),
                    },
                    {
                        key: 'point',
                        label: this.$t('grade'),
                    },
                ],
                examUpdateData: null,
                secondBranchOptions: [],
                programDataInfo: true,
                beforePlacedOptions: [
                    { value: 'E', text: this.$t('yes') },
                    { value: 'H', text: this.$t('no') }
                ],
                yesNoOptions: [
                    { value: 'H', text: this.$t('no') },
                    { value: 'E', text: this.$t('yes') }
                ],
            }
        },

        methods: {
            async updateForm(){
                this.formLoading = true
                const isValid = await this.$refs.updateFormValidate.validate();
                if (isValid) {
                    this.formData.mobile_tel = this.formData.mobile_tel.replace(/[^\d]/g, '')
                    this.formData.alternative_mobile_tel = this.formData.alternative_mobile_tel ? this.formData.alternative_mobile_tel.replace(/[^\d]/g, '') : null
                    if(this.formData.exam_date){
                        this.formData.exam_date = moment(this.formData.exam_date).format('YYYY-MM-DD')+' '+this.formData.exam_time;
                    }
                    delete this.formData.exam_time
                    this.formData.disability = this.formData.disability == 'E' ? 1 : 0
                    this.formData.before_placed = this.formData.before_placed == 'E' ? 1 : 0

                    CartoonAnimationService.update(this.formData,this.formData.id).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.formLoading = false
                        this.$emit('updated',true)
                    }).catch(e => {
                        this.showErrors(e, this.$refs.updateFormValidate)
                    })
                } else {
                    this.formLoading = false
                }
            },

            loadData(data) {
                this.newMessage()
                this.formData = data
                this.formData.city = parseInt(this.formData.city)
                this.formData.contact_city = parseInt(this.formData.contact_city)
                this.tabIndex = this.goTab
                if(this.formData.exam_date != null) {
                    let sp = this.formData.exam_date.split(' ')
                    this.formData.exam_date = sp[0]
                    this.formData.exam_time = sp[1].substr(0,5)
                }
                this.formData.disability = this.formData.disability == true ? 'E' : 'H'
                this.formData.program_code = '03092101'
                this.formData.before_placed = this.formData.before_placed == true ? 'E' : 'H'
                this.formData.has_university_enrollment = this.formData.has_university_enrollment ? 'E' : 'H'
            },

            downloadFile(type) {
                if(this.checkPermission('cartoonanimationapplication_downloadfile')) {
                    CartoonAnimationService.downloadFile(this.formData.id, type).then(response => {
                        this._downloadFile(response, response.headers.file_name)
                    }).catch(e => {
                        this.showErrors(e, null, true)
                    })
                } else {
                    this.$toast.error(this.$t('unauthorized_operation'))
                }
            },

            sendMessage(){
                if(this.message){
                    let formData = {
                        cartoon_animation_application_id: this.formData.id,
                        message: this.message
                    }
                    CartoonAnimationService.sendMessage(formData).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.formData.messages.push(response.data.data)
                        this.newMessage()
                    }).catch(e => {
                        this.showErrors(e)
                    })
                } else {
                    this.$toast.error(this.$t('message_is_required'))
                }
            },

            updateMessage(data){
                this.msgUpdateMode = true
                this.message = data.message
                this.msgDate = data.date
                this.msgId = data.id
            },

            newMessage(){
                this.msgUpdateMode = false
                this.message = null
                this.msgDate = null
                this.msgId = null
            },

            _updateMessage(){
                if(this.message && this.msgDate){
                    let formData = {
                        message: this.message,
                        date: this.msgDate
                    }
                    CartoonAnimationService.updateMessage(formData, this.msgId).then(response => {
                        this.$emit('updatedMsg', true)
                        this.formData.messages.forEach((itm, index) => {
                            if(itm.id == this.msgId) {
                                this.formData.messages.splice(index, 1)
                            }
                        })
                        this.formData.messages.push(response.data.data)
                        this.newMessage()
                        this.$toast.success(this.$t('api.'+response.data.message))
                    }).catch(e => {
                        this.showErrors(e)
                    })
                } else {
                    this.$toast.error(this.$t('message_date_is_required'))
                }
            },

            deleteMessage(messageId){
                this.$swal({
                    title: this.$t('attention'),
                    text: this.$t('message_delete_confirm'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                }).then(response => {
                    if (response.isConfirmed == true) {
                        CartoonAnimationService.deleteMessage(messageId).then(response => {
                            this.$toast.success(this.$t('api.'+response.data.message))
                            this.$emit('updatedMsg', true)
                            this.newMessage()
                            this.formData.messages.forEach((itm, index) => {
                                if(itm.id == messageId) {
                                    this.formData.messages.splice(index, 1)
                                }
                            })
                        }).catch(e => {
                            this.showErrors(e)
                        })
                    }
                })
            },

            getExamData(){
                const config = {
                    params: {
                        filter: {
                            cartoon_animation_application_id: this.updateData.id
                        },
                        limit: -1
                    },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
                }
                CartoonAnimationService.getExams(config).then(response => {
                    this.examResultData = response.data.data
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            openExamUpdate(data){
                this.examUpdateData = data
                this.$bvModal.show('examUpdateModal')
            },

            async updateExamData(){
                const isValid = await this.$refs.examUpdateFormValidate.validate();
                if (isValid) {
                    CartoonAnimationService.updateExam(this.examUpdateData,this.examUpdateData.id).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.examUpdateData = null
                        this.$bvModal.hide('examUpdateModal')
                    }).catch(e => {
                        this.showErrors(e)
                    })
                }
            },

            checkProgramCode(event){
                this.formData.second_program_detail = ''
                if(['11012101','11032101'].includes(this.formData.program_code) && this.formData.program_code == event){
                    this.programDataInfo = false
                    this.$swal({
                        title: this.$t('attention'),
                        text: 'Aynı program ikinci kez seçilemez !',
                        showCancelButton: false,
                        confirmButtonText: this.$t('ok'),
                    }).then(response => {
                        if (response.isConfirmed == true) {
                            this.programDataInfo = true
                        }
                    })
                    this.formData.second_program_code = null
                }
            },

            selectedSchool(data){
                if(data){
                    this.formData.school_code = data.code
                }
            },
        },

        watch: {
            updateData: {
                handler(value) {
                    this.loadData(value)
                }
            },

            goTab: {
                handler(value) {
                    this.tabIndex = value
                }
            },

            tabIndex: {
                handler(value) {
                    if (value == 4) {
                        this.getExamData()
                    }
                }
            },
        },

        created() {
            // Branch Options
            this.loadData(this.updateData)
        },
    }
</script>
